// extracted by mini-css-extract-plugin
export var select = "_r5-0";